export default __webpack_public_path__ + "images/00caa7cf2d76010b3d01e4ca1a88076c-agnostic.jpg";